import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd, {message} from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import * as Icons from '@ant-design/icons-vue'
import axios from 'axios'
import './assets/js/enums'
import './assets/css/global.css'

// createApp(App).use(Antd).use(store).use(router).mount('#app')

const app = createApp(App);
app.use(Antd).use(store).use(router).mount('#app')

const icons = Icons;
for(const i in icons) {
    app.component(i, icons[i]);
}

//axios log拦截器
axios.interceptors.request.use(function (config) {
    console.log('axios-Request-Log:', config);
    //给所有axios请求加上token令牌
    const token = store.state.userInfo.token;
    if(token){
        config.headers.token = token;
        console.log("请求接口Header.token-->", token)
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    console.log('axios-Response-Log:', response);
    return response;
}, (error) => {
    console.log('axios-Response-Error-Log:', error);

    // 当请求返回 401 时跳转登录（无 response 时可能为断网/跨域/超时，勿读 status）
    const response = error.response;
    if (response && response.status === 401) {
        //token过期，重新登录
        console.log('登录超时或没有权限!');
        store.commit('setUserInfo', {});
        message.error("登录超时或没有权限!")
        router.push('/login');
    }
    return Promise.reject(error);
});

//axios 设置baseURL
axios.defaults.baseURL = process.env.VUE_APP_SERVER

//打印环境变量
console.log('环境：', process.env.NODE_ENV)
console.log('接口地址：', process.env.VUE_APP_SERVER)
console.log('页面地址：', process.env.VUE_APP_WEB)